import { inject, observer } from 'mobx-react';
import queryString from 'query-string';
import React, { Component } from "react";
import { MenuItem, Nav, Navbar, NavDropdown, NavItem } from "react-bootstrap";
import { Link } from "react-router-dom";
import { compose } from 'recompose';
import AuthContext from './auth-context';
import history from './history';

class MainNavbar extends Component {
  static contextType = AuthContext;

  bookSeminarRegistration = () => {
    const profile = this.context.profile
    const data = {
      m1_booking_user: profile.email,
    }
    const params = queryString.stringify(data)
    let url = `${process.env.REACT_APP_SREG_URL}?${params}`
    window.open(url, "_blank")
  }

  bookTCS = () => {
    const profile = this.context.profile
    const data = {
      m1_booking_user: profile.email,
    }
    const params = queryString.stringify(data)
    let url = `${process.env.REACT_APP_BOOKING_URL}?${params}`
    window.open(url, "_blank")
  }

  bookRestrictedTCS = () => {
    const profile = this.context.profile
    const data = {
      m1_booking_user: profile.email,
      booking_from: "tcs_coach",
      business_stream: "webinar_no_show"
    }
    const params = queryString.stringify(data)
    let url = `${process.env.REACT_APP_BOOKING_URL}?${params}`
    window.open(url, "_blank")
  }

  render() {
    const authStore = this.context
    const { dialerStore } = this.props
    const profile = authStore.profile
    const isAdmin = authStore.hasRole('admin')
    const isRestrictedCoach = authStore.hasRole('coach_restricted')
    const isVoiceEnabled = authStore.hasRole('voice_enabled')

    return (
      <Navbar fluid collapseOnSelect>
        <Navbar.Header>
          <Navbar.Brand>
            <Link to="/m1/dashboard">EC</Link>
          </Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header>
        <Navbar.Collapse>
          <Nav>
            {!isRestrictedCoach && (
              <NavItem
                componentClass={Link}
                eventKey={1.1}
                to="/m1/deals/list/open"
                href="/m1/deals/list/open"
              >
                Deals
              </NavItem>
            )}

            {!isRestrictedCoach && (
              <NavDropdown
                eventKey={2}
                title="Seminars"
                id="basic-nav-dropdown"
              >
                {!isRestrictedCoach && (
                  <MenuItem
                    componentClass={Link}
                    eventKey={1}
                    to="/m1/seminars"
                    href="/m1/seminars"
                  >
                    Seminar List
                  </MenuItem>
                )}
                <MenuItem divider />
                {isAdmin && !isRestrictedCoach && (
                  <MenuItem
                    componentClass={Link}
                    eventKey={1}
                    to="/m1/seminars/new"
                    href="/m1/seminars/new"
                  >
                    Create New Seminar
                  </MenuItem>
                )}
                <MenuItem divider />
                {!isRestrictedCoach && (
                  <NavItem
                    componentClass={Link}
                    eventKey={23}
                    to=""
                    onClick={() => this.bookSeminarRegistration()}
                  >
                    ATAR SUCCESS Registration
                  </NavItem>
                )}
              </NavDropdown>
            )}
            <NavDropdown eventKey={2} title="Coaching" id="basic-nav-dropdown">
              <NavItem
                componentClass={Link}
                eventKey={2.1}
                to="/m1/tcs/list/today"
                href="/m1/tcs/list/today"
              >
                Trial Coaching List
              </NavItem>
              <NavItem
                componentClass={Link}
                eventKey={2.2}
                to="/m1/tcs/calendar"
                href="/m1/tcs/calendar"
              >
                Trial Coaching Calendar
              </NavItem>
              <MenuItem divider />
              {!isRestrictedCoach && (
                <NavItem
                  componentClass={Link}
                  eventKey={2.3}
                  to=""
                  onClick={() => this.bookTCS()}
                >
                  New Booking
                </NavItem>
              )}
            </NavDropdown>

            {isRestrictedCoach && (
              <NavItem
                componentClass={Link}
                eventKey={2.3}
                to=""
                onClick={() => this.bookRestrictedTCS()}
              >
                Book TCS
              </NavItem>
            )}

            <NavItem
              componentClass={Link}
              eventKey={2.5}
              to="/m1/follow_ups/list/today"
              href="/m1/follow_ups/list/today"
            >
              Follow Ups
            </NavItem>

            <NavItem
              componentClass={Link}
              eventKey={15.1}
              to="/m1/contacts/list/all"
              href="/m1/contacts/list/all"
            >
              Contacts
            </NavItem>

            <NavItem
              componentClass={Link}
              eventKey={3.2}
              to="/m1/call_records/list/open_voicemail"
              href="/m1/call_records/list/open_voicemail"
            >
              Call Records
            </NavItem>

            <NavItem
              componentClass={Link}
              eventKey={2.6}
              to="/m1/sales_person_tasks"
              href="/m1/sales_person_tasks"
            >
              Tasks
            </NavItem>

            {isAdmin && (
              <NavItem
                componentClass={Link}
                eventKey={6}
                to="/m1/confirmation_dashboard/list/tcs_confirmed_not_presented"
                href="/m1/confirmation_dashboard/list/tcs_confirmed_not_presented"
              >
                Call Dashboard
              </NavItem>
            )}
          </Nav>
          <Nav pullRight>
            {isVoiceEnabled && (
              <NavItem
                componentClass={Link}
                eventKey={4.1}
                to=""
                onClick={() =>
                  (dialerStore.showDialer = !dialerStore.showDialer)
                }
              >
                <i className="far fa-phone-square" /> {dialerStore.systemStatus}
              </NavItem>
            )}
            <NavDropdown
              eventKey={5}
              title={
                <div style={{ display: "inline-block" }}>
                  <i className="far fa-user" /> {profile.first_name}{" "}
                  {profile.last_name}
                </div>
              }
              id="basic-nav-dropdown"
            >
              {isAdmin && (
                <NavItem
                  componentClass={Link}
                  eventKey={5.31}
                  to="/m1/reporting/funnels"
                  href="/m1/reporting/funnels"
                >
                  Reporting
                </NavItem>
              )}
              {isAdmin && (
                <NavItem
                  componentClass={Link}
                  eventKey={5.32}
                  to="/m1/users"
                  href="/m1/users"
                >
                  Users
                </NavItem>
              )}
              <MenuItem divider />
              {isAdmin && (
                <NavItem
                  componentClass={Link}
                  eventKey={5.11}
                  to="/m1/admin/holidays"
                  href="/m1/admin/holidays"
                >
                  Admin Holidays
                </NavItem>
              )}

              {isAdmin && (
                <NavItem
                  componentClass={Link}
                  eventKey={5.3}
                  to="/m1/admin/leadmachine"
                  href="/m1/admin/leadmachine"
                >
                  Admin LeadMachine
                </NavItem>
              )}
              {isAdmin && (
                <NavItem
                  componentClass={Link}
                  eventKey={5.4}
                  to="/m1/admin/messaging"
                  href="/m1/admin/messaging"
                >
                  Admin Messaging
                </NavItem>
              )}
              {isAdmin && (
                <NavItem
                  componentClass={Link}
                  eventKey={5.5}
                  to="/m1/admin/integrations"
                  href="/m1/admin/integrations"
                >
                  Admin Integrations
                </NavItem>
              )}
              {isAdmin && (
                <NavItem
                  componentClass={Link}
                  eventKey={5.4}
                  to="/m1/admin/prompts"
                  href="/m1/admin/prompts"
                >
                  Ai Analysis Prompts
                </NavItem>
              )}
              {isAdmin && (
                <NavItem
                  componentClass={Link}
                  eventKey={5.6}
                  to="/m1/admin/templates"
                  href="/m1/admin/templates"
                >
                  Admin Email Templates
                </NavItem>
              )}

              {isAdmin && (
                <NavItem
                  componentClass={Link}
                  eventKey={5.7}
                  to="/m1/admin/overdue-sales-emails"
                  href="/m1/admin/overdue-sales-emails"
                >
                  Overdue Sales Emails
                </NavItem>
              )}

              {isAdmin && (
                <NavItem
                  componentClass={Link}
                  eventKey={5.8}
                  to="/m1/admin/systemlog"
                  href="/m1/admin/systemlog"
                >
                  Admin System Log
                </NavItem>
              )}

              {isAdmin && (
                <NavItem
                  componentClass={Link}
                  eventKey={5.9}
                  to="/m1/admin/api-keys"
                  href="/m1/admin/api-keys"
                >
                  API Keys
                </NavItem>
              )}

              <NavItem
                eventKey={5.6}
                onClick={() => {
                  this.context.logout();
                  history.replace("/login");
                }}
              >
                Logout
              </NavItem>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}
export default compose(inject('dialerStore'))(observer(MainNavbar));
